let lastMessage: string | null = null;

export function showBundledRuntimeError(message: string): void {
  lastMessage = message;
  console.error('[bundled]', message);

  const el = document.getElementById('app');
  if (!el) {
    window.alert(message);

    return;
  }

  let overlay = document.getElementById('bundled-error-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'bundled-error-overlay';
    overlay.setAttribute(
      'style',
      [
        'position:fixed',
        'inset:0',
        'z-index:99999',
        'background:rgba(255,255,255,0.97)',
        'padding:24px',
        'overflow:auto',
        'font-family:system-ui,sans-serif',
        'color:#1f2937',
      ].join(';'),
    );
    el.appendChild(overlay);
  }

  overlay.innerHTML = `
    <h1 style="font-size:18px;font-weight:700;margin:0 0 8px">Erro no app</h1>
    <p style="margin:0 0 12px;line-height:1.5">Feche e abra de novo. Se continuar, envie ao suporte:</p>
    <pre style="white-space:pre-wrap;background:#f3f4f6;padding:12px;border-radius:8px;font-size:12px">${escapeHtml(message)}</pre>
    <button type="button" id="bundled-error-dismiss" style="margin-top:16px;padding:10px 16px;border-radius:8px;border:1px solid #d1d5db;background:#fff;font-size:14px">Fechar</button>
  `;

  document.getElementById('bundled-error-dismiss')?.addEventListener('click', () => {
    overlay?.remove();
  });
}

export function installBundledVueErrorHandler(app: import('vue').App): void {
  app.config.errorHandler = (error, _instance, info) => {
    const message =
      error instanceof Error
        ? `${error.message}\n(${info})`
        : `Erro inesperado (${info})`;

    if (message === lastMessage) {
      return;
    }

    showBundledRuntimeError(message);
  };
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
